import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2_END = {
  title: "Find out more about Infosys Network \nOperations from our staff.",
  bgImage: "ILO/ILO2/ILO_demo_bg_end.jpg",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage("ILO_201"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ILO_204"),
      endIcon: "arrow-right",
    },
  ],
};

export default DATA_NO_DEMO_ILO2_END;
